import useAuth from '@modules/AuthModule/hooks/useAuth';

function isTenantId(value?: string): boolean {
  return value != null && !isNaN(Number(value));
}

function useTenantName(tenantNameOrId: string): string {
  const auth = useAuth();

  if (!isTenantId(tenantNameOrId)) {
    return tenantNameOrId;
  }

  const tenant = auth.user?.org.tenants.find(
    (tenant) => tenant.id === tenantNameOrId,
  );

  return tenant?.name || 'Unknown';
}

export default useTenantName;
